import { TooltipStyled, TooltipStyledProps } from '@OnArk/styles/Layout.styled';

import React, { ReactElement } from 'react';

import { css } from '@emotion/react';
import * as Icons from '@OnArk/SVGs/icons';

export default function Icon({
  className,
  color = 'currentColor',
  left = '0',
  name,
  right = '0.5',
  size,
  toolTipSize = 'big',
  tooltip,
  ...props
}: {
  color?: string;
  name: IconName;
  size: string;
  toolTipSize?: string;
  tooltip?: string;
  left?: string;
  right?: string;
} & Omit<TooltipStyledProps, 'size' | 'children'>): ReactElement {
  // *.svg modules are ambiently `any` (next/image-types); each export is an
  // @svgr/webpack React component taking standard SVG props.
  const IconSVG = Icons[name] as
    | React.ComponentType<React.SVGProps<SVGSVGElement>>
    | undefined;

  if (!IconSVG) return <></>;
  const ParentComponent = ({ children }: React.PropsWithChildren<any>) =>
    tooltip ? (
      <TooltipStyled
        position="right"
        size={toolTipSize}
        title={tooltip}
        {...props}
        delay={[300, 0]}
      >
        {children}
      </TooltipStyled>
    ) : (
      <>{children}</>
    );

  return (
    <ParentComponent>
      <i
        className={className}
        css={css`
          display: inline-block;
          margin-right: ${right}rem;
          margin-left: ${left}rem;

          line-height: 0px;
          vertical-align: middle;
          * {
            fill: ${color};
          }
        `}
      >
        <IconSVG height={size} width={size} />
      </i>
    </ParentComponent>
  );
}
